import { useState } from "react";
import { faqItems } from "@/mocks/faq";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-4xl px-5 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Merak Edilenler"
            title="Sık Sorulan Sorular"
            description="Randevu ve kampanyalar hakkında en çok sorulan soruların yanıtlarını burada bulabilirsiniz."
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-3">
          {faqItems.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <Reveal key={item.id} delay={index * 60}>
                <div className="overflow-hidden rounded-xl border border-background-300/70 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                  >
                    <span className="font-heading text-base font-semibold tracking-tight text-foreground-950 md:text-lg">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border transition-colors ${
                        isOpen
                          ? "border-accent-500 bg-accent-500 text-primary-950"
                          : "border-background-300 text-accent-700"
                      }`}
                    >
                      <i
                        className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}
                        aria-hidden="true"
                      />
                    </span>
                  </button>

                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 font-body text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}